export interface AppendCursor {
  count: number;
  tailID: string;
}

export function compactRunMachineState<T extends object>(run: T): Omit<T, "equipmentDrops"> {
  const { equipmentDrops: _equipmentDrops, ...state } = run as T & { equipmentDrops?: unknown };
  return state;
}

export function appendedItems<T extends { id: string }>(
  items: T[],
  cursor: AppendCursor,
  knownIDs: Set<string>,
): { added: T[]; cursor: AppendCursor } {
  const appended =
    cursor.count <= items.length &&
    (cursor.count === 0 || items[cursor.count - 1]?.id === cursor.tailID);
  const added = appended
    ? items.slice(cursor.count)
    : items.filter((item) => !knownIDs.has(item.id));
  for (const item of added) knownIDs.add(item.id);
  return {
    added,
    cursor: {
      count: items.length,
      tailID: items.at(-1)?.id ?? "",
    },
  };
}
